/**
 * PersonalIcon — ID card with portrait.
 * Maps to: Entity Category bucket = Personal (Individual / Minor / NRA / UTMA).
 * Color ramp: Blue (#185FA5).
 * Source: docs/pcb-icons-svg-v2.3/entity/PersonalIcon.svg
 */
import type { JSX } from 'react';
import type { IconProps } from '../types';

export function PersonalIcon({
  size = 40,
  'aria-label': ariaLabel = 'Personal — individual ID card',
  ...rest
}: IconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      fill="none"
      role="img"
      aria-label={ariaLabel}
      {...rest}
    >
      <title>Personal</title>
      <desc>Icon depicting an identification card with portrait, representing individual consumer accounts.</desc>
      <rect x="6" y="10" width="36" height="28" rx="2" fill="#185FA5" />
      <circle cx="16" cy="22" r="3.5" fill="#E6F1FB" />
      <path d="M11 31 Q16 27 21 31" fill="none" stroke="#E6F1FB" strokeWidth="1.5" />
      <line x1="25" y1="18" x2="38" y2="18" stroke="#E6F1FB" strokeWidth="1.2" />
      <line x1="25" y1="22" x2="36" y2="22" stroke="#E6F1FB" strokeWidth="1.2" />
      <line x1="25" y1="26" x2="38" y2="26" stroke="#E6F1FB" strokeWidth="1.2" />
      <line x1="25" y1="30" x2="34" y2="30" stroke="#E6F1FB" strokeWidth="1.2" />
    </svg>
  );
}

export default PersonalIcon;
